import { date, object, ref, string } from 'yup';
import { IOptionalService } from '../../optional-services';

export type IResidentOptionalService = {
  id: string;
  nursingHomeId: string;
  residentId: string;
  optionalService?: IOptionalService;
  optionalServiceId: string;
  invoicedFrom: Date;
  invoicedUntil: Date | null;
  remark: string | null;
};

export type IResidentOptionalServiceCreate = {
  optionalServiceId: string;
  invoicedFrom: Date;
  invoicedUntil?: Date | null;
  remark?: string | null;
};

export const IResidentOptionalServiceCreateSchema = object({
  optionalServiceId: string().required(),
  invoicedFrom: date().required(),
  invoicedUntil: date().nullable().optional().min(ref('invoicedFrom')).default(null),
  remark: string().nullable().optional(),
});

export type IResidentOptionalServiceUpdate = {
  invoicedUntil?: Date | null;
  remark?: string | null;
};

export const IResidentOptionalServiceUpdateSchema = object({
  invoicedUntil: date().nullable().optional(),
  remark: string().nullable().optional(),
});
